$(document).ready(customProduct);
document.addEventListener("ShoptetDOMPageContentLoaded", customProduct);
document.addEventListener("ShoptetPageSortingChanged", customProduct);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", customProduct);
document.addEventListener("ShoptetDOMContentLoaded", customProduct);

function customProduct() {
  $(".product").each(function () {
    const $product = $(this);

    if ($product.find(".p-tools form").length) {
      if (!$product.find(".quantity").length) {
        $product.find(".p-tools form").prepend($quantity);
      }
    } else {
      $product.find(".p-tools a").text("Detail produktu");
    }

    if (!$product.find(".p-bottom .ratings-wrapper").length) {
      $product.find(".p-bottom>div").append($product.find(".ratings-wrapper").clone());
    }
    const $priceStandard = $product.find(".price-standard");
    if ($priceStandard.length) {
      $(".flag-discount").html(function (_, html) {
        return html.replace("od", "");
      });
      if (!$product.find(".prices .price-standard").length) {
        $product.find(".prices").prepend($priceStandard);
      }
    }
    if (!$product.find(".p-bottom .availability .deliveryDate").length) {
      const availabilityText = $product.find(".p-bottom .availability > span:not(.availability-amount)").text().trim().toLowerCase();
      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (!deliveryDate) return;
      const formatted = formatDeliveryDate(deliveryDate, false);
      $product.find(".p-bottom .availability").append(`<div class="deliveryDate">můžete mít ${formatted}</div>`);
    }
    if ($product.find(".p-bottom .availability-amount").length) {
      $product.find(".p-bottom .availability-amount").each(function () {
        var text = $(this).text();
        text = text.replace(/[()]/g, "");
        $(this).text(text);
      });
    }
    $product.find(".p-bottom .availability").attr("style", $product.find(".p-bottom .availability>span").attr("style"));
  });
  $(".favorites-list .product, .rvList .product").hover(
    function () {
      const $img = $(this).find(".image img");

      const originalSrc = $img.attr("src");
      const newSrc = $img.attr("data-src");

      if (newSrc && originalSrc !== newSrc) {
        $img.data("original-src", originalSrc);
        $img.attr("src", newSrc);
      }
    },
    function () {
      const $img = $(this).find(".image img");

      const originalSrc = $img.data("original-src");

      if (originalSrc) {
        $img.attr("src", originalSrc);
      }
    },
  );
}

var $quantity = `
    <span class="quantity">
        <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMax" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMin" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <label>
            <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount">
        </label>
        <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
            <span class="increase__sign">+</span>
        </button>
        <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
            <span class="decrease__sign">−</span>
        </button>
    </span>
`;

$("html").on("click", ".products .product button.add-to-cart-button", function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var inputVal = $(this).closest(".p-tools").find("input").val();
  var inputPriceId = $(this).closest(".p-tools").find('input[name="priceId"]').attr("value");
  shoptet.cartShared.addToCart({ priceId: inputPriceId, amount: inputVal });
});

if ($("body.in-index").length) {
  $(".homepage-products-heading-1").append(`<span class="tm">${Bestsellery}</span>`);
  $(".homepage-products-heading-2").append(`<span class="tm">${textNovinky}</span>`);

  $(".products-block#products-1").each(function () {
    $(this).after('<a class="btn btn-secondary" href="/akcni-nabidka/">Zobrazit všechny produkty</a>');
  });
}
